import { twMerge } from 'tailwind-merge';
import type { PendingTask } from '@/providers/NewCaseProvider';
import Card from '@/components/Card';
import StepStatus from '../StepStatus';
import type { CreationStepStatus } from '../../types';
import { CREATION_STEP_STATUS } from '../../constants';
import { classes } from '../utils';

const { PENDING } = CREATION_STEP_STATUS;

export type TaskRowProps = {
  task: PendingTask;
  status: CreationStepStatus;
  onRetry: () => void;
};

export default function TaskRow({ task, status, onRetry }: TaskRowProps) {
  return (
    <Card
      className={twMerge(classes.card, status === PENDING && classes.pending)}>
      <StepStatus status={status} onRetry={onRetry} />
      {task.description || 'Task'}
    </Card>
  );
}
